import { UtilityService } from 'src/app/core/utility.service'
import { environment } from 'src/environments/environment'
import {
  AccessRights,
  UserRole
} from 'src/app/features/role/user-role/user-role'
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy'
import { Component, OnInit } from '@angular/core'
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators
} from '@angular/forms'
import { AppState } from 'src/app/core/core.state'
import { Store } from '@ngrx/store'
import { TranslatorService } from 'src/app/core/translator.service'
import { NotificationService } from 'src/app/core/notification.service'
import { DEFAULT_YEAR_MATRIX } from 'src/app/shared/constants'
import { BehaviorSubject, Observable, Subject, of } from 'rxjs'
import { persistentUserRoleSelectors } from '../../role/user-role/persistent-user-role/persistent-user-role.selector'
import {
  catchError,
  filter,
  take,
  timeout,
  withLatestFrom
} from 'rxjs/operators'
import { Actions, ofType } from '@ngrx/effects'
import { MetaOption, MetaOptionKeys } from '../../meta-option/meta-option'
import { MetaOptionService } from '../../meta-option/meta-option.service'
import { metaOptionSelectors } from '../../meta-option/meta-option.selectors'
import { RequestQueryBuilder } from '@nestjsx/crud-request'
import { metaOptionActions } from '../../meta-option/meta-option.actions'
import moment from 'moment-mini'

@UntilDestroy()
@Component({
  selector: 'year-calendar-tab',
  templateUrl: './show.component.html',
  styleUrls: ['./show.component.scss']
})
export class YearCalendarTabComponent implements OnInit {
  public getDataFromCalendar$: Subject<boolean> = new Subject()
  public sendselectedYear$: BehaviorSubject<any> = new BehaviorSubject(
    moment().year()
  )
  public sendCalendar$: BehaviorSubject<any> = new BehaviorSubject([])
  public form: UntypedFormGroup
  public accessRights = AccessRights
  public isCreatedBeforeMetaOptions: boolean = false
  public defaultYearMatrixMetaOption$: Observable<MetaOption>
  public isLoading$: Observable<boolean>
  public currentUserRole$: Observable<UserRole>
  private metaOption: MetaOption
  public selectedYear
  public years = []
  private INITIAL_YEAR = 2000
  private FINAL_YEAR = 2050
  constructor(
    private fb: UntypedFormBuilder,
    private actions$: Actions,
    public store: Store<AppState>,
    private translatorService: TranslatorService,
    private notificationService: NotificationService,
    private utilityService: UtilityService,
    private metaOptionService: MetaOptionService
  ) {}
  ngOnInit() {
    this.isLoading$ = this.store.select(metaOptionSelectors.selectIsLoading)
    this.years = Array.from(
      { length: this.FINAL_YEAR - this.INITIAL_YEAR + 1 },
      (_, index) => index + this.INITIAL_YEAR
    )
    this.form = this.fb.group({
      value: [null, [Validators.required]],
      years: [this.years, [Validators.required]]
    })
    this.form.controls.years.valueChanges
      .pipe(untilDestroyed(this))
      .subscribe((year) => {
        if (!year) return
        this.selectedYear = year.toString()
        this.sendselectedYear$.next(this.selectedYear)
        const yearIndex = Number(year) - 2000

        const actualYear = this.metaOption?.value.slice(
          96 * yearIndex,
          96 * yearIndex + 96
        )
        const binaryActualYear = this.utilityService.HextoBinary(actualYear)
        this.form.controls.value.setValue(
          this.utilityService.investBinary(binaryActualYear)
        )
        this.sendCalendar$.next(this.form.controls.value?.value?.split(''))
      })
    this.currentUserRole$ = this.store.select(
      persistentUserRoleSelectors.selectSelectedUserRole
    )

    this.currentUserRole$
      .pipe(
        filter((userRole) => userRole !== null && userRole !== undefined),
        take(1)
      )
      .subscribe((userRole) =>
        this.store.dispatch(
          metaOptionActions.fetchMany({
            params: RequestQueryBuilder.create({
              search: {
                key: MetaOptionKeys.DEFAULT_YEAR_MATRIX,
                siteId: userRole.siteId ?? 0
              }
            })
          })
        )
      )

    this.store
      .select(metaOptionSelectors.selectAll)
      .pipe(withLatestFrom(this.currentUserRole$), untilDestroyed(this))
      .subscribe(([allMetaOptions, userRole]) => {
        const effectiveSiteId = userRole?.siteId ?? 0
        this.metaOption = allMetaOptions.find(
          (option) =>
            option.key == MetaOptionKeys.DEFAULT_YEAR_MATRIX &&
            option.siteId === effectiveSiteId
        )

        if (this.metaOption?.value?.trim()?.length > 0) {
          this.isCreatedBeforeMetaOptions = true
          const date = new Date()
          const yearIndex = date.getFullYear() - 2000
          const monthIndex = date.getMonth()
          const dayIndex = date.getDate()
          this.selectedYear = date.getFullYear().toString()
          this.sendselectedYear$.next(this.selectedYear)
          // in yearsBuffer (yearCalendar in BBDD ) content year from 2000 to 2050  every year has 96 nums Hex=384bits (96x4bit) ,
          // every month has 8 nums Hex=32bits (8x4bit) if that bit is 1 is available and if is 0 is not available
          // so if one month is FFFFFFFF(1111 1111 1111 1111 1111 1111 1111 1111) is full available
          const actualYear = this.metaOption.value.slice(
            96 * yearIndex,
            96 * yearIndex + 96
          )
          const binaryActualYear = this.utilityService.HextoBinary(actualYear)
          this.form.controls.value.setValue(
            this.utilityService.investBinary(binaryActualYear)
          )
          this.sendCalendar$.next(this.form.controls.value?.value?.split(''))
        } else if (
          this.metaOption?.value?.trim()?.length == 0 ||
          !this.metaOption?.value
        ) {
          let selectedCalendar =
            this.utilityService.createStandardCurrentYearCaledar(
              this.FINAL_YEAR,
              this.INITIAL_YEAR
            )
          selectedCalendar = this.utilityService.BinarytoHex(
            this.utilityService.investBinary(selectedCalendar)
          )
          let metaOption = JSON.parse(JSON.stringify(this.metaOption ?? {}))
          metaOption.value = selectedCalendar
          this.metaOption = metaOption
          const date = new Date()
          const yearIndex = date.getFullYear() - 2000
          this.selectedYear = date.getFullYear().toString()
          this.sendselectedYear$.next(this.selectedYear)
          const actualYear = selectedCalendar.slice(
            96 * yearIndex,
            96 * yearIndex + 96
          )
          const binaryActualYear = this.utilityService.HextoBinary(actualYear)
          this.form.controls.value.setValue(
            this.utilityService.investBinary(binaryActualYear)
          )
          this.sendCalendar$.next(this.form.controls.value?.value?.split(''))
        }
      })
  }

  public onFormSubmit() {
    this.getDataFromCalendar$.next(true)
    if (!this.isCreatedBeforeMetaOptions) {
      this.onSubmit(this.form.value)
    } else {
      this.onPatch(this.form.value)
    }
  }

  public transformData(data) {
    this.form.controls.value.setValue(data.toString().replaceAll(',', ''))
  }

  public onPatch(form): void {
    if (!this.selectedYear) {
      this.form.controls['years'].setErrors({ required: true })
      return
    }
    if (this.metaOption) {
      this.store.dispatch(
        metaOptionActions.updateOneById({
          id: this.metaOption.id,
          params: {
            value: this.standarizeCalendar(form)
          }
        })
      )
    }

    this.actions$
      .pipe(
        ofType(metaOptionActions.upsertMany),
        take(1),
        timeout(5000),
        catchError((error) => of(null))
      )
      .subscribe((action) =>
        action
          ? this.notificationService.emit('alerts.success', 'success')
          : null
      )
  }

  public onSubmit(form): void {
    if (!this.selectedYear) {
      this.form.controls['years'].setErrors({ required: true })
      return
    }
    this.store
      .select(persistentUserRoleSelectors.selectSelectedUserRole)
      .pipe(
        filter((pUr) => pUr !== null && pUr !== undefined),
        take(1)
      )
      .subscribe((pUr) => {
        const siteId = pUr.siteId ?? environment.defaultSiteId
        this.store.dispatch(
          metaOptionActions.createOne({
            entity: {
              value: this.standarizeCalendar(form),
              key: DEFAULT_YEAR_MATRIX,
              siteId: siteId
            }
          })
        )
      })

    this.actions$
      .pipe(
        ofType(metaOptionActions.upsertMany),
        take(1),
        timeout(5000),
        catchError((error) => of(null))
      )
      .subscribe((action) =>
        action
          ? this.notificationService.emit('alerts.success', 'success')
          : null
      )
  }

  private standarizeCalendar(form) {
    const initYearCalendar = this.metaOption?.value
      ? this.metaOption?.value
      : this.utilityService.createYearCalendar().join('')
    const yearIndex = Number(this.selectedYear) - 2000
    const calendarToHex = this.utilityService.BinarytoHex(
      this.utilityService.investBinary(form.value)
    )

    const newYearCalendar =
      initYearCalendar.slice(0, 96 * yearIndex) +
      calendarToHex.toUpperCase() +
      initYearCalendar.slice(96 * yearIndex + 96)
    return newYearCalendar
  }
}
